export const fragenWertverlustAutoGuide = [
  {
    question: "Beeinflussen Farben den Wert?",
    answer: (
      <>
        <p>
          Ja. Neutrale Farben wie Schwarz, Weiß und Silber gelten als zeitlos und
          erhöhen den Wiederverkaufswert. Exotische Farben finden weniger Käufer.
        </p>
      </>
    ),
  },
  {
    question: "Sind Dieselautos wertlos?",
    answer: (
      <>
        <p>
          Nein, aber sie verlieren aufgrund gesetzlicher Einschränkungen und
          Umweltzonen schneller an Wert. Käufer suchen oft nach Benzinern oder
          Hybridmodellen.
        </p>
      </>
    ),
  },
  {
    question: "Wie wirkt sich ein Unfall aus?",
    answer: (
      <>
        <p>
          Ein Unfallfahrzeug verliert stark an Wert, selbst wenn es fachgerecht
          repariert wurde. Lasse Reparaturen dokumentieren und beauftrage
          unabhängige Gutachter.
        </p>
      </>
    ),
  },
  {
    question: "Gibt es bei Elektroautos höheren Wertverlust?",
    answer: (
      <>
        <p>
          Elektroautos haben bisher stabilere Restwerte, weil die Nachfrage
          steigt. Allerdings können technologische Sprünge (z. B. neue
          Batteriechemie) den Wert älterer Modelle drücken.
        </p>
      </>
    ),
  },
];

